import { FeaturedIcon } from '@ad-lucy/ui';
import { useI18n } from '@i18n/i18n.utils';
import {
  Actions,
  Message,
  StyledView,
  Subtitle,
  Title,
} from './ErrorView.styled';
import type { IErrorView } from './ErrorView.types';

export function ErrorView({
  className,
  hideActions = false,
  icon = 'IconAlertCircle',
  iconVariant = 'error',
  secondaryAction,
  primaryAction,
  subtitle,
  title,
}: Readonly<IErrorView>): JSX.Element {
  const { t } = useI18n();

  return (
    <StyledView className={className} data-testid="view.pageNotFound">
      <Message>
        <FeaturedIcon type={icon} variant={iconVariant} />
        <Title weight="bold">{title ?? t('errorView.general.title')}</Title>
        <Subtitle size="xl">
          {subtitle ??
            `${t('errorView.general.subtitle')}\n${t('errorView.general.subtitleSecondary')}`}
        </Subtitle>
      </Message>
      {!hideActions && (
        <Actions>
          {secondaryAction}
          {primaryAction}
        </Actions>
      )}
    </StyledView>
  );
}
